import { get, getArrayBuffer } from '@/helpers/httpHandler';
import { cloneDeep } from 'lodash';

export default {
  getItemsList({ commit }, { params } = {}) {
    return get(`/planning/list-tasks`, {
      ...params.filters,
      ...params.paginationOptions
    }).then(response => {
      commit('setFilters', cloneDeep(params.filters));
      commit('setPaginationOptions', cloneDeep(params.paginationOptions));

      return response;
    });
  },

  getTasksExport(_, params) {
    return getArrayBuffer(`/planning/tasks-export`, params);
  },

  filterOrderNumber({ commit }, params) {
    return get(`/planning/filters/tasks/order-number`, params).then(
      response => {
        return response;
      }
    );
  },

  filterEmployee({ commit }, params) {
    return get(`/planning/filters/tasks/employee`, params).then(response => {
      return response;
    });
  },

  filterCustomer({ commit }, params) {
    return get(`/planning/filters/tasks/customer`, params).then(response => {
      return response;
    });
  }
};
